import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { ProjectRegisterValidationComponent } from './project-register-validation.component';
import { ProjectValidationApproveModalComponent } from './project-validation-approve-modal/project-validation-approve-modal.component';
import { ProjectValidationDetailsDrawerComponent } from './project-validation-details-drawer/project-validation-details-drawer.component';
import { ProjectValidationRejectModalComponent } from './project-validation-details-drawer/project-validation-reject-modal/project-validation-reject-modal.component';
import { ProjectValidationRejectConfirmModalComponent } from './project-validation-reject-confirm-modal/project-validation-reject-confirm-modal.component';

@NgModule({
  declarations: [
    ProjectRegisterValidationComponent,
    ProjectValidationDetailsDrawerComponent,
    ProjectValidationRejectModalComponent,
    ProjectValidationRejectConfirmModalComponent,
    ProjectValidationApproveModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    ProjectRegisterValidationComponent,
  ],
  providers: [
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectRegisterValidationModule { }
